"use client";

import Image from "next/image";
import Link from "next/link";
import { useAuth } from "@/contexts/AuthContext";

export default function Footer() {
  const { user, logout } = useAuth();
  return (
    <footer className="bg-white border-t py-4 md:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 md:gap-8">
          {/* Logo Section */}
          <div className="space-y-4">
            <div className="flex items-center justify-center lg:justify-start">
              <Image
                src="/images/logo.webp"
                alt="TopCat Helicopters"
                width={40}
                height={40}
                className="mr-3"
              />
              <span className="text-lg font-bold text-gray-900">
                TopCat Helicopters
              </span>
            </div>
            <p className="text-sm text-gray-600 text-center lg:text-left">
              Your sky is the limit
            </p>
          </div>

          {/* Column 2 - Services */}
          <div className="hidden lg:block text-center lg:text-left">
            <h3 className="font-semibold text-gray-900 mb-3">Services</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>Theory Courses</li>
              <li>Sightseeing Flights</li>
              <li>Private Pilot Training</li>
              <li>Night Flying</li>
            </ul>
          </div>

          {/* Column 3 - Training */}
          <div className="hidden lg:block text-center lg:text-left">
            <h3 className="font-semibold text-gray-900 mb-3">Training</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>Robinson R22/R44</li>
              <li>Turbine Helicopters</li>
              <li>VFR Night Rating</li>
              <li>Type Ratings</li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div className="hidden lg:block text-center lg:text-left">
            <h3 className="font-semibold text-gray-900 mb-3">Contact</h3>
            <div className="space-y-2 text-sm text-gray-600">
              <p>+32 475 28 51 93</p>
              <p>topcathelicopters@gmail.com</p>
              <p>Belgium</p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 my-3 md:my-6"></div>
        <div className="flex flex-col space-y-3 lg:flex-row lg:justify-between lg:items-center lg:space-y-0">
          <div className="text-center lg:text-left">
            <p className="text-xs lg:text-sm text-gray-500">
              © 2025 TopCat Helicopters. All rights reserved.
            </p>
            <p className="text-xs lg:text-sm text-gray-500">
              Developed by{" "}
              <a
                href="https://www.nlabs.be"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
              >
                NLABS BV
              </a>
            </p>
          </div>

          {/* Desktop: Show navigation links */}
          <div className="hidden lg:flex gap-4 items-center">
            <a
              href="#services"
              className="text-sm text-gray-500 hover:text-accent transition-colors"
            >
              Services
            </a>
            <a
              href="#about"
              className="text-sm text-gray-500 hover:text-accent transition-colors"
            >
              About Us
            </a>
            <a
              href="#contact"
              className="text-sm text-gray-500 hover:text-accent transition-colors"
            >
              Contact
            </a>
            <div className="h-4 w-px bg-gray-300 mx-2"></div>
            {user ? (
              <button
                onClick={logout}
                className="text-sm bg-accent text-white px-3 py-1.5 rounded-md hover:bg-accent/90 transition-colors"
              >
                Logout
              </button>
            ) : (
              <Link
                href="/login"
                className="text-sm bg-accent text-white px-3 py-1.5 rounded-md hover:bg-accent/90 transition-colors"
              >
                Login
              </Link>
            )}
          </div>
        </div>

        {/* Mobile: Show login/logout button */}
        <div className="lg:hidden flex justify-center mt-4">
          {user ? (
            <button
              onClick={logout}
              className="text-sm bg-accent text-white px-4 py-2 rounded-md hover:bg-accent/90 transition-colors"
            >
              Logout
            </button>
          ) : (
            <Link
              href="/login"
              className="text-sm bg-accent text-white px-4 py-2 rounded-md hover:bg-accent/90 transition-colors"
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
}
